import { useState } from 'react';

export default function useCountStep(initialStep = 1, maxSteps = 3) {
  const [currentStep, setCurrentStep] = useState(initialStep);

  const nextStep = () => {
    setCurrentStep((prev) => (prev < maxSteps ? prev + 1 : prev));
  };

  const prevStep = () => {
    setCurrentStep((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const goToStep = (step) => {
    if (step >= 1 && step <= maxSteps) {
      setCurrentStep(step);
    }
  };

  const resetStep = () => {
    setCurrentStep(initialStep);
  };

  return {
    currentStep,
    nextStep,
    prevStep,
    goToStep,
    resetStep,
    isFirstStep: currentStep === 1,
    isLastStep: currentStep === maxSteps,
    maxSteps,
  };
}
